// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Creates an auth helper instance using APIKey. Its `getLocationClientConfig` function creates a signer to set the
 * APIKey in all the commands of a client.
 *
 * @param apiKey APIKey
 */
export async function withAPIKey(apiKey) {
    return {
        getLocationClientConfig: () => ({
            signer: {
                sign: async (requestToSign) => {
                    var _a;
                    // APIKey in the command can override the APIKey set by auth helper.
                    requestToSign.query = Object.assign({ key: apiKey }, ((_a = requestToSign.query) !== null && _a !== void 0 ? _a : {}));
                    return requestToSign;
                },
            },
        }),
    };
}
